import { render, staticRenderFns } from "./chatGroup.vue?vue&type=template&id=513edb1a&scoped=true&"
import script from "./chatGroup.vue?vue&type=script&lang=js&"
export * from "./chatGroup.vue?vue&type=script&lang=js&"
import style0 from "./chatGroup.vue?vue&type=style&index=0&id=513edb1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513edb1a",
  null
  
)

export default component.exports